import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation, BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

// ScrollToTop component to handle scroll behavior
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    console.log('sccroll to top')
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
import Layout from './components/layout/Layout'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import MemberServicesPage from './pages/MemberServicesPage'
import BespokeShoppingPage from './pages/BespokeShoppingPage'
import EditorialPage from './pages/EditorialPage'
import ContactPage from './pages/ContactPage'
import AdminPage from './pages/AdminPage'
import AestheticsAntiAgingPage from './app/member-services/aesthetics-anti-aging/page'
import ApplyMembershipPage from './pages/ApplyMembershipPage'
import MembershipEnquiryPage from './pages/MembershipEnquiryPage'
import ArticleDetailPage from './pages/ArticleDetailPage'
import ArtworkPage from './pages/bespoke-shopping/ArtworkPage'
import CigarsPage from './pages/bespoke-shopping/CigarsPage'
import DiamondsPage from './pages/bespoke-shopping/DiamondsPage'
import EstatesPage from './pages/bespoke-shopping/EstatesPage'
import FineWinePage from './pages/bespoke-shopping/FineWinePage'
import MoutaiPage from './pages/bespoke-shopping/MoutaiPage'
import WatchesPage from './pages/bespoke-shopping/WatchesPage'
import WhiskeyPage from './pages/bespoke-shopping/WhiskeyPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsPage from './pages/TermsPage'
import ArtEscrowConsultingPage from './app/member-services/art-escrow-consulting/page'
import BlackCarServicePage from './app/member-services/black-car-service/page'
import EducationConsultingPage from './app/member-services/education-consulting/page'
import InviteOnlyLoungePage from './app/member-services/invite-only-lounge/page'
import PersonalTravelPlannerPage from './app/member-services/personal-travel-planner/page'
import PrivateDiningPage from './app/member-services/private-dining/page'
import PrivateJetCharterPage from './app/member-services/private-jet-charter/page'
import TicketingEventsPage from './app/member-services/ticketing-events/page'
import YachtCharterPage from './app/member-services/yacht-charter/page'

function App() {

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            {/* Main Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/member-services" element={<MemberServicesPage />} />
            <Route path="/bespoke-shopping" element={<BespokeShoppingPage />} />
            <Route path="/editorial" element={<EditorialPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/admin/login" element={<AdminPage />} />
            
            {/* Member Services Routes */}
            <Route path="/member-services/aesthetics-anti-aging" element={<AestheticsAntiAgingPage />} />
            <Route path="/apply-membership" element={<ApplyMembershipPage />} />
            <Route path="/membership-enquiry" element={<MembershipEnquiryPage />} />
            <Route path="/member-services/art-escrow-consulting" element={<ArtEscrowConsultingPage />} />
            <Route path="/member-services/black-car-service" element={<BlackCarServicePage />} />
            <Route path="/member-services/education-consulting" element={<EducationConsultingPage />} />
            <Route path="/member-services/invite-only-lounge" element={<InviteOnlyLoungePage />} />
            <Route path="/member-services/personal-travel-planner" element={<PersonalTravelPlannerPage />} />
            <Route path="/member-services/private-dining" element={<PrivateDiningPage />} />
            <Route path="/member-services/private-jet-charter" element={<PrivateJetCharterPage />} />
            <Route path="/member-services/ticketing-events" element={<TicketingEventsPage />} />
            <Route path="/member-services/yacht-charter" element={<YachtCharterPage />} />
            
            {/* Bespoke Shopping Routes */}
            <Route path="/bespoke-shopping/artwork" element={<ArtworkPage />} />
            <Route path="/bespoke-shopping/cigars" element={<CigarsPage />} />
            <Route path="/bespoke-shopping/diamonds" element={<DiamondsPage />} />
            <Route path="/bespoke-shopping/estates" element={<EstatesPage />} />
            <Route path="/bespoke-shopping/fine-wine" element={<FineWinePage />} />
            <Route path="/bespoke-shopping/moutai" element={<MoutaiPage />} />
            <Route path="/bespoke-shopping/watches" element={<WatchesPage />} />
            <Route path="/bespoke-shopping/whiskey" element={<WhiskeyPage />} />
            
            {/* Editorial Routes */}
            <Route path="/editorial/:slug" element={<ArticleDetailPage />} />
            
            {/* Legal Pages */}
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  )
}

export default App